module.exports = __webpack_public_path__ + "img/quickbook_btn_logo.8c1e74fd.png";